import * as http from '@/utils/http.js';
import { getPlatformSource } from '@/utils/utils';
import * as ww from '@wecom/jssdk';
import Cookies from 'js-cookie';

const corpId = 'ww303dba6eae5bee8a';
const agentId = 1000011;

// 设置debug
const _debug = {
  externalUserid: '',
  setData: function(cropUserId, externalUserid) {
    Cookies.set('WorkCropUserId', cropUserId, { expires: 0.01 }); // 过期时间约14分钟左右
    this.externalUserid = externalUserid;
  }
};


// 获取url参数
function getQueryVariable(myKey, href) {
  if (!href) {
    href = window.location.href;
  }
  let regExp = new RegExp(`(?:&|\\?)${myKey}=([^&]*)(&|$)`);
  let result = '';
  let matchs = href.match(regExp);
  if (matchs) {
    result = matchs[1];
  }
  return result;
}

// 是否在企业微信中
function isInWework() {
  // Web下调试
  if (_debug.externalUserid) return true;

  return getPlatformSource() === 'wework';
}

// 企业微信OAuth2认证获取用户Code
function jumpToAuthorizeUri() {
  /* 线上环境重定向之后的解析 */
  const appid = corpId;
  const agentid = agentId;
  const redirectUri = encodeURIComponent(window.location.href);
  const baseUrlStart = 'https://open.weixin.qq.com/connect/oauth2/authorize?';
  const baseUrlEnd = '&response_type=code&scope=snsapi_base#wechat_redirect'; // 静默授权不获取手机号
  // var baseUrlEnd = '&response_type=code&scope=snsapi_privateinfo#wechat_redirect'; // 手动授权获取更多信息
  // 跳转到oAuth企业微信服务器
  window.location.replace(`${baseUrlStart}appid=${appid}&agentid=${agentid}&redirect_uri=${redirectUri}${baseUrlEnd}`);
  // window.alert(`${baseUrlStart}appid=${appid}&agentid=${agentid}&redirect_uri=${redirectUri}${baseUrlEnd}`);
}

// 获取企业微信签名
async function getJsApiSignature(type, url) {
  let result = await http._post({
    url: '/wework/index/getJsApiSignature',
    data: {
      url: url,
      type: type
    }
  });

  console.log('[/wework/index/getJsApiSignature]', type, result);
  return result;
}

/**
 *
 * @return Bool 是否登陆成功
 */
async function authorizeCropUser() {
  // 是否在企业微信中
  if (!isInWework()) {
    return Promise.reject(new Error('仅能在企业微信中使用'));
  }

  // 获取 cookie 中的企业员工ID
  let cropUserId = Cookies.get('WorkCropUserId');
  if (cropUserId) {
    return Promise.resolve(cropUserId);
  }

  // 获取Auth授权code
  const code = getQueryVariable('code');
  if (code) {
    // 根据 code 获取用户ID
    let result = await http._post({
      url: '/wework/index/getCropUserIdByCode',
      data: {
        code: code
      }
    });
    console.log('[/wework/index/getCropUserIdByCode]', code, result);

    if (result.errcode !== 0) {
      return Promise.reject(new Error(result.errmsg || '接口错误 getCropUserIdByCode'));
    }
    if (result.UserId) {
      // 保存cookie
      Cookies.set('WorkCropUserId', result.UserId, { expires: 30 }); // 过期时间30天
      return Promise.resolve(result.UserId);
    }
    // 获取了OpenId等非员工
    return Promise.reject(new Error('非企业员工，无法使用系统'));
  }
  return Promise.resolve(false);
}

function getCurExternalContact() {
  // Web下调试
  if (_debug.externalUserid) {
    return Promise.resolve(_debug.externalUserid);
  }

  return new Promise((resolve, reject) => {
    // 是否在企业微信中
    if (!isInWework()) {
      return reject(new Error('仅能在企业微信中使用'));
    }

    /**
     * 注册应用信息，SDK主页 https://www.npmjs.com/package/@wecom/jssdk
     */
    ww.register({
      corpId: corpId,
      agentId: agentId,
      jsApiList: [
        'agentConfig',
        'getCurExternalChat',
        'getCurExternalContact',
      ],
      async getConfigSignature(url) {
        return getJsApiSignature('config', url);
      },
      onConfigFail() {
        reject(new Error('初始化 config 失败'));
      },
      onConfigComplete() {
      },
      async getAgentConfigSignature(url) {
        return getJsApiSignature('agentConfig', url);
      },
      onAgentConfigFail() {
        reject(new Error('初始化 agentConfig 失败'));
      },
      onAgentConfigComplete() {
      }
    });

    // 可以立刻调用JS接口，无需等待ready回调
    ww.getCurExternalContact({
      success(res) {
        resolve(res.userId); // customerId
      },
      fail(res) {
        console.error(res);
        reject(new Error(res.errMsg));
      }
    });
  });
}

export default {
  corpId,
  agentId,
  _debug,
  isInWework,
  authorizeCropUser,
  getCurExternalContact,
  jumpToAuthorizeUri,
  getQueryVariable,
  getJsApiSignature
};
